module.exports = __webpack_public_path__ + "img/pay_successful2.41481a26.png";